import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { compose } from 'redux';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import get from 'lodash/get';
import defer from 'lodash/defer';
import has from 'lodash/has';
import debounce from 'lodash/debounce';

import {
  findReportByAssignmentIdSectionId,
  learnosityReportByUsers,
} from 'legacy-src/utility/progressHelpers';
import { hasOptionalPractice } from 'legacy-src/utility/helpers';
import { useTable } from 'chameleon/ui-stack/ui/base/table';
import studentOptionalPracticeQuiz from 'legacy-src/components/assessment/hooks/studentOptionalPracticeQuiz';
import Preview from 'chameleon/ui-stack/ui/assessments/preview';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import {
  sortAssessmentResults,
  sortAssessmentTitle,
  sortAssessmentStatus,
  sortAssessmentByDate,
} from './util';
import { getTotalSubmissions } from 'chameleon-src/components/learnosity/utils/helpers';
import {
  ASSESSMENT_STATUSES,
  STATUS,
} from 'chameleon-src/constants/assessmentStatus';
import VideoResourcePreviewWrapper from 'chameleon-src/components/VideoResourcePreviewWrapper';
import Pagination from 'legacy-src/components/assessment/Assessments/Pagination';
import RenderRow from './TeacherAssessmentsTableRows';
import { createPutRequest } from 'legacy-src/components/TeacherOrganize/hooks/utils/apiHelpers';
import { resourceTypes } from 'legacy-src/components/TeacherOrganize/utils/constants';
import ResourceTypes from 'legacy-packages/unit-outline/src/constants';
import { withCourseOutline } from 'chameleon-packages/units';
import getCourseOutlineResourcesByType from 'legacy-src/utility/helpers/getCourseOutlineResourcesByType';
import useLocalStorage from 'chameleon/ui-stack/ui/base/hooks/use-local-storage';
import useLabelsDnD from './labels-dnd';
import { sendToTelemetry, TLTRY_DEFAULTS } from 'legacy-src/utility/telemetry';
import usePerformanceTiers from 'chameleon/src/hooks/usePerformanceTiers';

const AssessmentsTable = ({
  data,
  subjectInfo,
  noDataText = 'No items found',
  params: { subject },
  router,
  location,
  location: { query = {}, pathname = '' },
  options = {},
  userData: { isStudent = false, isTeacher, me },
  featureFlag,
  loadAssignments = () => {},
  currentEducationPeriod,
  studentsBySection,
  client,
  reportsData,
  cachedDates,
  setCachedDates,
  isBuildQuizUnassigned,
  previewBaseUrl = null,
  unassignedDateAccessor = 'date_updated',
  onPreviewQuiz = null,
  closeQuizReturnPath = null,
  shouldStoreActionTelementryEvent = false,
  telemetryEventApp = 'assessment/unassigned',
  courseOutline,
  setIsReorderInProgress = () => {},
}) => {
  const flatResultsWithReports = useRef([]);
  const resultsWithReports = useRef([]);
  const [list, setList] = useState([]);
  const { queryParams, pushParamsToHistory, hasLabelsParams } = useNavigation({
    router,
  });

  const { performanceTiers } = usePerformanceTiers(subject);

  const flatFilters = ['starts_at', 'due_at', 'results', 'status'];

  const {
    classes: teacherClasses,
    id: subjectInitId,
    isPreApSubject = false,
  } = subjectInfo || {};

  const { initId: userId } = me || {};
  const [saveItemToLocalStorage, , getSavedSortOrder] = useLocalStorage({
    key: `sortBy`,
    itemKey: `${userId}-${subject}`,
    index: 1,
  });
  const savedFilters = JSON.parse(getSavedSortOrder() || '[]');
  const currentSortBy = useRef(get(savedFilters, ['0', 'id']));

  const teacherClassesInCurrentEducationPeriod =
    (teacherClasses &&
      teacherClasses.filter(
        (cls) => +cls.educationPeriod === +currentEducationPeriod.id,
      )) ||
    [];
  const teacherHasMultipleClasses =
    teacherClassesInCurrentEducationPeriod.length > 1;

  const {
    student_practice_results: showStudentPracticeResultsFlag,
    show_my_assignments_date_picker: showStartDueDateDatepicker,
    my_assignment_page_size: tablePageSizeFF,
    shared_assessments: sharedAssessmentsFF,
    shared_quiz_icons: sharedQuizIconsFF,
    teacher_organize_reorder: teacherOrganizeReorderFF,
    my_assignments_pdf: myAssignmentsPdfFF,
    labels_dnd: labelsDnDFF,
    no_reload_remove_label: noReloadRemoveLabelFF,
    no_reload_update_label: noReloadUpdateLabelFF,
  } = featureFlag;

  const hasData = list.length > 0;

  const { groups = [] } = options;
  let groupsWithStudents = [];
  const subjectClasses = teacherClasses;

  if (groups && subjectClasses) {
    // mix rest and graphQL responses
    groupsWithStudents = groups.map((group) => {
      const sameClass = subjectClasses.find(
        (klass) => parseInt(klass.id, 10) === parseInt(group.id, 10),
      );
      const students = (sameClass && sameClass.students) || [];
      return { ...group, students };
    });
  }

  const mappedGroups = isEmpty(groupsWithStudents)
    ? groups
    : groupsWithStudents;

  const hasStudentInClasses = (sectionId) => {
    const result =
      teacherClasses && teacherClasses.find((c) => c.id === `${sectionId}`);
    return result && (result.students || []).length > 0;
  };

  const isAllResourcesPage = queryParams.status
    ?.split(',')
    .every((selectedStatus) =>
      ASSESSMENT_STATUSES?.find((status) => status === selectedStatus),
    );

  const isAssignedResourcesPage = queryParams.status === STATUS.ALL_ASSIGNED;

  const isLabelFilterActive = Boolean(queryParams.labels);

  const headers = [
    {
      Header: 'Title',
      className: `pl-8 ${
        isAllResourcesPage || isBuildQuizUnassigned ? 'w-2/3' : 'w-1/4'
      } text-base`,
      accessor: 'title',
      sortType: sortAssessmentTitle(),
      disableSortBy: isBuildQuizUnassigned,
    },
    {
      Header: '',
      id: 'labels',
      className: 'w-1/6 text-base',
    },
    {
      Header: 'Last Modified',
      className: 'w-1/6 text-base',
      accessor: 'date_updated',
      id: 'date_updated',
      sortType: sortAssessmentByDate('date_updated'),
    },
    {
      Header: 'Date Created',
      id: 'date_created',
      className: 'w-1/6 text-base',
      accessor: 'date_created',
      sortType: sortAssessmentByDate('date_created'),
    },
    {
      Header: 'Start date',
      id: 'starts_at',
      className: 'w-1/6 text-base start-date-th',
      disableSortBy: isAllResourcesPage,
      accessor(a) {
        const getDate = (a) => a.starts_at || a.startsAt || a.opened;
        if (a?.assignments?.length === 0) {
          return -1;
        }
        return (
          a &&
          a.assignments &&
          a.assignments.length > 0 &&
          Number(new Date(getDate(a.assignments[0])))
        );
      },
    },
    {
      Header: 'Due date',
      id: 'due_at',
      className: 'w-1/6 text-base due-date-th',
      disableSortBy: isAllResourcesPage,
      accessor(a) {
        const getDate = (a) => a.due_at || a.dueAt || 0;
        if (a?.assignments?.length === 0) {
          return -1;
        }
        return (
          a &&
          a.assignments &&
          a.assignments.length > 0 &&
          Number(new Date(getDate(a.assignments[0])))
        );
      },
    },
    {
      Header: 'Status',
      className: 'w-1/6 text-base status-th',
      id: 'status',
      accessor(a) {
        if (has(a, 'status')) {
          return a.status;
        } else if (has(a, 'is_assigned_in_subject')) {
          return a.is_assigned_in_subject ? 'Assigned' : 'Unassigned';
        }
        return '—';
      },
      disableSortBy:
        queryParams.status === STATUS.COMPLETED || isBuildQuizUnassigned,
      sortType: sortAssessmentStatus(),
    },
    {
      Header: 'Results',
      className: 'w-2/6 text-base results-th',
      accessor: 'results',
      sortType: sortAssessmentResults(),
      disableSortBy: isAllResourcesPage,
    },
    {
      id: 'actions',
      Header: '',
      className: 'pr-8 w-1/12',
    },
  ];

  const prepareDataRows = (dataList) =>
    dataList.map((rowData) => {
      const { assignments = [] } = rowData;

      if (assignments && assignments.length) {
        const { assign } = Object;
        const singleClassMultipleAssignments =
          !teacherHasMultipleClasses && assignments.length > 1;
        const singleClassIsaOnly =
          !teacherHasMultipleClasses &&
          assignments.length === 1 &&
          get(assignments[0], 'sub_group_students', []).length;

        if (
          teacherHasMultipleClasses ||
          singleClassIsaOnly ||
          singleClassMultipleAssignments
        ) {
          return assign(
            {
              isAssessmentRow: true,
              subRows: [rowData],
            },
            rowData,
          );
        }

        return assign({ showAssessmentName: true }, rowData);
      }

      return rowData;
    });

  let hiddenColumns = ['date_created', 'date_updated'];

  if (isAllResourcesPage) {
    hiddenColumns = ['results', 'starts_at', 'due_at', 'date_created'];
  } else if (isBuildQuizUnassigned) {
    hiddenColumns = ['results', 'starts_at', 'due_at', 'date_created'];
  }

  const {
    Table,
    TableBody,
    TableColumns,
    TableHeader,
    sortBy,
    tableItems,

    // pagination
    pageCount,
    gotoPage,
    pageIndex,
  } = useTable({
    data: list,
    headers,
    hasPagination: true,
    autoResetPage: false,
    isManualSorting: false, // set to false to use default table sorting
    initialState: {
      pageSize: tablePageSizeFF || 30,
      hiddenColumns,
      sortBy: savedFilters,
    },
  });

  useEffect(() => {
    if (data?.length > 0) {
      const { displayAssignmentLinkTeacher } = studentOptionalPracticeQuiz({
        showStudentPracticeResultsFlag,
        isStudent,
        isPreApSubject,
      });

      let filteredResults = data;

      if (hasOptionalPractice(pathname)) {
        filteredResults = data.filter((result) => {
          const {
            item: { contains_secure_questions },
            question_types,
            awaiting_scoring,
          } = result;
          return (
            displayAssignmentLinkTeacher(
              contains_secure_questions,
              question_types,
              awaiting_scoring,
            ) && result
          );
        });
      }

      const flatReports = [];
      const unassignedReports = filteredResults.filter(
        (result) => result.assignments.length === 0,
      );
      const reports = filteredResults.map((result) => {
        const { is_spp: isSPP } = result || {};
        const assignments = result.assignments.map((assignment) => {
          const {
            section_id: sectionId,
            sub_group_students: subGroupStudents,
          } = assignment || {};
          const report = reportsData
            ? findReportByAssignmentIdSectionId(
                reportsData,
                assignment.id,
                assignment.section_id,
              )
            : {};

          const hasScoredResult = !isEmpty(report);
          const hasStudents = getTotalSubmissions(assignment.progress) !== 0;
          const isVideo = result.type === 'video';
          const reportByUsers =
            hasScoredResult && learnosityReportByUsers([report]);

          const getScoreData = () => {
            /**
             * For videos and SPPs, all the students count towards the average whereas all
             * other assignments only count the number of students who have submitted.
             *
             * Video progress already comes back as a percentage i.e. 90, 50, 49, which
             * is why we don't * 100
             */
            if (isVideo) {
              const studentProgress = get(
                assignment,
                'progress.student_progress',
                [],
              );
              const studentCount = studentProgress.length || 1;
              const totalScore = studentProgress.reduce(
                (watched, progress) => watched + progress.watched_percentage,
                0,
              );
              return {
                studentCount,
                scorePercentage: totalScore / studentCount,
              };
            }

            if (isSPP) {
              const sectionStudents = get(studentsBySection, sectionId, []);
              const studentCount = (
                (subGroupStudents || []).length > 0
                  ? subGroupStudents
                  : sectionStudents
              ).length;
              const totalScore = sectionStudents.reduce(
                (total, { id: userId }) => {
                  const reportForUser = get(reportByUsers, userId, {
                    score: 0,
                    max_score: 1,
                  });
                  const { max_score, score } = reportForUser;
                  return total + parseInt(score, 10) / parseInt(max_score, 10);
                },
                0,
              );
              return {
                studentCount,
                scorePercentage: (totalScore / studentCount) * 100,
              };
            }

            /**
             * Everything below here depends on learnosity reports, if LRN returns nothing
             * then the average is automatically 0
             */
            if (!reportByUsers) {
              return {
                studentCount: 0,
                scorePercentage: 0,
              };
            }

            const totalScore = Object.values(reportByUsers).reduce(
              (average, reportForUser) => {
                const { max_score, score } = reportForUser || {
                  score: 0,
                  max_score: 1,
                };
                return average + parseInt(score, 10) / parseInt(max_score, 10);
              },
              0,
            );
            const studentCount = Object.keys(reportByUsers).length;
            return {
              studentCount,
              scorePercentage: (totalScore / studentCount) * 100,
            };
          };
          const { studentCount, scorePercentage } = getScoreData();

          const assignmentWithReport = {
            ...assignment,
            report,
            hasStudents,
            scorePercentage: scorePercentage || 0,
            studentCount: studentCount || 0,
          };

          flatReports.push({ ...result, assignments: [assignmentWithReport] });
          return assignmentWithReport;
        });

        return {
          ...result,
          assignments,
        };
      });

      const preparedReport = prepareDataRows(reports);

      resultsWithReports.current = preparedReport;
      flatResultsWithReports.current = prepareDataRows([
        ...flatReports,
        ...unassignedReports,
      ]);
      const isFlatFilter = flatFilters.includes(get(savedFilters, ['0', 'id']));
      setList(
        isFlatFilter
          ? flatResultsWithReports.current
          : resultsWithReports.current,
      );
    } else {
      setList([]);
    }
  }, [data]);

  useEffect(() => {
    defer(() => gotoPage(parseInt(queryParams.page, 10)));
  }, [queryParams.page]);

  useEffect(() => {
    const newSortBy = get(sortBy, ['0', 'id']);

    saveItemToLocalStorage(JSON.stringify(sortBy));

    // early exit, no need to keep going if the new sort is the same as the previous
    if (newSortBy === currentSortBy.current) return () => {};

    if (
      flatFilters.includes(newSortBy) &&
      !flatFilters.includes(currentSortBy.current)
    ) {
      /**
       * Only set the list with flat values if we are switching from a grouped to a flat
       * sorting column, otherwise there's no need to.
       */
      setList(flatResultsWithReports.current);
    } else if (
      (['title'].includes(newSortBy) || !newSortBy) &&
      flatFilters.includes(currentSortBy.current)
    ) {
      /**
       * Only set the list with grouped values if we are
       * - coming from a flat filter to a title filter, or
       * - coming from a flat filter to no filter
       * otherwise
       * the list does not need to be re-set.
       */
      setList(resultsWithReports.current);
    }
    currentSortBy.current = newSortBy;
  }, [JSON.stringify(sortBy)]);

  const basePathname = `/${subject}/assignments`;

  const openVideo = ({ location, videoUrl }) => {
    pushParamsToHistory({ apd: videoUrl }, location.pathname);
  };

  const hasTableItems = Boolean(hasData && tableItems.length);
  const teacherStudentsBySectionNullCheck = isTeacher && studentsBySection.null;
  const moveItemPersistDebounced = debounce(
    async (data, labelId, onError = () => {}) => {
      /** data format to save
       * [
       *   {id: <assessment-id>, type: 'item'},
       *   {id: <video-id>, type: 'video'},
       *   {id: <video-id>, type: 'video'},
       *   {id: <pdf-id>, type: 'pdf'},
       *   {id: <assessment-id>, type: 'item'},
       *   {id: <assessment-id>, type: 'item'},
       * ]
       */
      const response = await createPutRequest({
        url: `/assessments/api/label/${labelId}/associations/reorder`,
        params: data.map((row) => ({
          id: row.id,
          type: [resourceTypes.video, resourceTypes.pdf].includes(row.type)
            ? row.type
            : resourceTypes.item,
        })),
      });
      if (response) {
        setIsReorderInProgress(false);

        if (!response.success) {
          onError();
        }
      }
    },
    1000,
  );

  const moveItem = async (from, to) => {
    const updatedData = window.structuredClone(list);
    const originalList = list;
    const tmp = updatedData[to];
    updatedData[to] = updatedData[from];
    updatedData[from] = tmp;
    setList(updatedData);
    setIsReorderInProgress(true);
    moveItemPersistDebounced.cancel();
    moveItemPersistDebounced(updatedData, queryParams.labels, () => {
      // on BE error revert the order
      setList(originalList);
    });
  };
  const subjectCourseOutlineUnits = courseOutline?.units || [];
  const resources = getCourseOutlineResourcesByType(
    subjectCourseOutlineUnits,
    ResourceTypes.EMBEDDED_VIDEO,
  );
  /**
   * The Assign action for Resources (videos) requires the CO object.
   * This cache will be used to quickly get the resource the action requires.
   */
  const videoResourcesByResourceId = resources.reduce((acc, resource) => {
    acc[resource?.resourceId] = resource;
    return acc;
  }, {});

  const updateLabelsInData = (
    data,
    assessmentId,
    labelId,
    resourceId,
    type,
    labelIds,
  ) => {
    const updatedData = window.structuredClone(data);

    const updateLabels = (data, id, labelId) => {
      const indices = data.reduce((indices, item, index) => {
        if (item.id === id) indices.push(index);
        return indices;
      }, []);

      indices.forEach((index) => {
        if (hasLabelsParams && queryParams.labels === labelId) {
          data.splice(index, 1);
        } else {
          data[index].labels = data[index].labels?.filter(
            (id) => id.toString() !== labelId,
          );
        }
      });
    };

    const updateResourceLabels = (data, resourceId, type, labelIds) => {
      const indices = data.reduce((indices, resource, index) => {
        if (
          resource.id === resourceId &&
          (resource.type === type || type === resourceTypes.item)
        ) {
          indices.push(index);
        }
        return indices;
      }, []);

      indices.forEach((index) => {
        if (
          hasLabelsParams &&
          !labelIds.includes(Number.parseInt(queryParams.labels, 10))
        ) {
          data.splice(index, 1);
        } else {
          data[index].labels = labelIds;
        }
      });
    };

    if (assessmentId) {
      updateLabels(updatedData, assessmentId, labelId);
    } else if (resourceId) {
      updateResourceLabels(updatedData, resourceId, type, labelIds);
    }

    return updatedData;
  };

  /*When adding/removing labels, we update the list and the caches (flatResultsWithReports and resultsWithReports)**/
  const updateData = (id, labelId, resourceId, type, labelIds) => {
    const updatedList = updateLabelsInData(
      list,
      id,
      labelId,
      resourceId,
      type,
      labelIds,
    );
    const updatedFlatResultsWithReports = updateLabelsInData(
      flatResultsWithReports.current,
      id,
      labelId,
      resourceId,
      type,
      labelIds,
    );
    const updatedResultsWithReports = updateLabelsInData(
      resultsWithReports.current,
      id,
      labelId,
      resourceId,
      type,
      labelIds,
    );

    setList(updatedList);
    flatResultsWithReports.current = updatedFlatResultsWithReports;
    resultsWithReports.current = updatedResultsWithReports;
  };

  const onLabelRemoved = (assessmentId, labelId) => {
    updateData(assessmentId, labelId);
  };

  const onResourceLabelUpdate = ({ resourceId, type, labelIds }) => {
    updateData(null, null, resourceId, type, labelIds);
  };

  const onLabelAdded = (assessmentId, labelId) => {
    const addLabel = (data, id, labelId) => {
      const items = data.filter((item) => item.id === id);
      items.forEach((item) => {
        if (!item.labels.includes(labelId)) {
          item.labels.push(labelId);
        }
      });
    };

    let updatedList = window.structuredClone(list);
    let updatedFlatResultsWithReports = window.structuredClone(
      flatResultsWithReports.current,
    );
    let updatedResultsWithReports = window.structuredClone(
      resultsWithReports.current,
    );

    addLabel(updatedList, assessmentId, labelId);
    addLabel(updatedFlatResultsWithReports, assessmentId, labelId);
    addLabel(updatedResultsWithReports, assessmentId, labelId);

    setList(updatedList);
    flatResultsWithReports.current = updatedFlatResultsWithReports;
    resultsWithReports.current = updatedResultsWithReports;
  };

  const tableItemsMapper = (item) => (
    <RenderRow
      key={item.id}
      studentsBySection={studentsBySection}
      row={item}
      isLast={item.index === list.length - 1}
      showReorderActions={
        teacherOrganizeReorderFF &&
        hasLabelsParams &&
        !queryParams.type &&
        !queryParams.status &&
        sortBy.length === 0
      }
      router={router}
      location={location}
      basePathname={basePathname}
      TableColumns={TableColumns}
      openVideo={openVideo}
      mappedGroups={mappedGroups}
      performanceTiers={performanceTiers}
      hasStudentInClasses={hasStudentInClasses}
      loadAssignments={loadAssignments}
      subjectInfo={subjectInfo}
      query={query}
      client={client}
      showStartDueDateDatepicker={showStartDueDateDatepicker}
      onLabelRemoved={noReloadRemoveLabelFF ? onLabelRemoved : loadAssignments}
      me={me}
      cachedDates={cachedDates}
      setCachedDates={setCachedDates}
      previewBaseUrl={previewBaseUrl}
      unassignedDateAccessor={unassignedDateAccessor}
      onPreviewQuiz={onPreviewQuiz}
      closeQuizReturnPath={closeQuizReturnPath}
      shouldStoreActionTelementryEvent={shouldStoreActionTelementryEvent}
      telemetryEventApp={telemetryEventApp}
      sharedAssessmentsFF={sharedAssessmentsFF}
      sharedQuizIconsFF={sharedQuizIconsFF}
      myAssignmentsPdfFF={myAssignmentsPdfFF}
      // Disabled Drag and Drop on QB Edit Quiz
      // and for anyone else who's not a teacher
      labelsDnDFF={!isTeacher || isBuildQuizUnassigned ? false : labelsDnDFF}
      isAllResourcesPage={isAllResourcesPage}
      isAssignedResourcesPage={isAssignedResourcesPage}
      addColumnPadding={!isAllResourcesPage && isLabelFilterActive}
      moveItem={moveItem}
      videoResourcesByResourceId={videoResourcesByResourceId}
      onResourceLabelUpdate={
        noReloadUpdateLabelFF ? onResourceLabelUpdate : loadAssignments
      }
    />
  );

  /**
   * By making the body it's own component here, we make sure it re-renders
   * when the tableItems change i.e. when using pagination and/ or when sorting
   */
  const Body = ({ items, hasItems }) => (
    <TableBody>{hasItems && items.map(tableItemsMapper)}</TableBody>
  );

  const sendTelemetry = useCallback(
    (eventType, details) => {
      const { id: amUserId, pilot } = window.current_user || {};
      sendToTelemetry({
        app: 'assessments',
        event_type: eventType,
        details,
        user: {
          am_user_id: amUserId,
          pilot,
          cb_user_id: userId,
        },
        context: {
          subject_id: subjectInitId,
        },
        ...TLTRY_DEFAULTS[0],
      });
    },
    [userId, subjectInitId],
  );

  /**
   * Add drag and drop functionality to assessment rows
   *
   **/
  const { LabelOverlay } = useLabelsDnD({ onLabelAdded, sendTelemetry });

  /**
   * the studentsBySection.null condition allows us to prevent a race condition where the
   * page loads before the cache is populated. the default value of studentsBySection
   * (see bottom of the file) is {null: true} so as long as studentsBySection.null is true,
   * our cache has not been populated yet
   */
  if (teacherStudentsBySectionNullCheck) {
    return <LoadingSpinner />;
  }

  return (
    <Fragment>
      <Table className="mt-5">
        <TableHeader />
        <Body items={tableItems} hasItems={hasTableItems} />
      </Table>
      {!hasData && (
        <div
          data-test-id="no-data-text"
          className="w-100 bg-gray-100 rounded-xl border-dashed border-gray-500 border leading-8 text-2xl px-5 py-4 mt-6"
        >
          {noDataText}
        </div>
      )}
      {pageCount > 1 && (
        <Pagination
          className="mt-6 justify-end"
          totalPages={pageCount}
          currentPage={pageIndex}
          pathname={location.pathname}
          router={router}
        />
      )}
      {query.quizId && (
        <Preview
          onAssign={loadAssignments}
          previewId={query.quizId}
          groups={teacherClasses}
          subjectInitId={subjectInitId}
          masterSubjectId={subject}
          closePreviewLink={{ ...location, query: omit(query, ['quizId']) }}
        />
      )}
      {query.apd && <VideoResourcePreviewWrapper onAssign={loadAssignments} />}
      {LabelOverlay}
    </Fragment>
  );
};

function mapStateToProps(state) {
  const { isTeacher } = state.userData;

  return {
    subjectInfo: state.subject.data,
    featureFlag: state.featureFlag,
    /**
     * For some reason, the studentsBySection being a truthy value for admin/coords
     * prevented the assign modal from opening on the unassigned page. The reason why is
     * not understood, but the problem was traced to this particular line, Keeping the
     * value falsy for admin/coords ensures we don't have the problem anymore while ensuring
     * the race-condition (where we try to use studentsBySection before it's set) for
     * teachers is still avoided.
     */
    studentsBySection:
      state.studentsBySection || (isTeacher ? { null: true } : null),
    currentEducationPeriod:
      state.userData.educationPeriod.currentEducationPeriod,
  };
}

export default compose(
  withRouter,
  withApollo,
  withCourseOutline(),
  connect(mapStateToProps),
)(AssessmentsTable);
